import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const workerSendCode = (params) => {
  return Api(endPoints.workerSendCode, params, requestType.POST);
};

const registerWorker = (params) => {
  return Api(endPoints.registerWorker, params, requestType.POST);
};

const registerWorkerByCompany = (_, params) => {
  return Api(endPoints.companyRegisterWorker, params, requestType.POST);
};

const loginWorker = (params) => {
  return Api(endPoints.loginWorker, params, requestType.POST);
};

const updateWorkerProfile = (id, params) => {
  return Api(`${endPoints.updateWorkerProfile}/${id}`, params, requestType.PUT);
};

const getWorkerDetail = (id, type) => {
  return Api(
    `${endPoints.getWorkerDetail}/${id}?type=${type || "All"}`,
    null,
    requestType.GET
  );
};

const updateWorkderDetail = (id, params) => {
  return Api(`${endPoints.updateWorkderDetail}/${id}`, params, requestType.PUT);
};

const changeWorkerPassword = (params) => {
  return Api(endPoints.changeWorkerPassword, params, requestType.POST);
};

const getAllWorkersByCompanyId = (id, name = "") => {
  return Api(
    `${endPoints.getAllWorkersByCompanyId}/${id}?name=${name}`,
    null,
    requestType.GET
  );
};

const getWorkerReviews = (id, name) => {
  return Api(
    `${endPoints.getWorkerReviews}/${id}?username=${name || ""}`,
    null,
    requestType.GET
  );
};

const getWorkerDashboardStates = (id) => {
  return Api(
    `${endPoints.getWorkerDashboardStates}/${id}`,
    null,
    requestType.GET
  );
};

const getWorkerReport = (id, query) => {
  return Api(
    `${endPoints.getWorkerReport}/${id}?startDate=${query.startDate}&endDate=${query.endDate}`,
    null,
    requestType.GET
  );
};

const workerPurchaseSubscription = (params) => {
  return Api(endPoints.workerPurchaseSubscripton, params, requestType.POST);
};

const updateWorkerAvailability = (workerId, params) => {
  return Api(
    `${endPoints.updateWorkerAvailability}/${workerId}`,
    params,
    requestType.PUT
  );
};

const getWorkerAvailability = (workerId) => {
  return Api(
    `${endPoints.getWorkerAvailability}/${workerId}`,
    null,
    requestType.GET
  );
};

export {
  workerSendCode,
  registerWorker,
  loginWorker,
  updateWorkerProfile,
  changeWorkerPassword,
  getAllWorkersByCompanyId,
  registerWorkerByCompany,
  getWorkerReviews,
  getWorkerDashboardStates,
  getWorkerReport,
  getWorkerDetail,
  updateWorkderDetail,
  workerPurchaseSubscription,
  updateWorkerAvailability,
  getWorkerAvailability,
};
